<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    noSearchResult: {
      type: String,
      default: 'No results found',
    },
    inputPlaceholder: {
      type: String,
      default: 'Search',
    },
  },
  emits: ['add'],
  data() {
    return {
      search: '',
    };
  },
  computed: {
    hasValue() {
      if (this.selectedItems.length > 0) {
        return true;
      }
      return false;
    },
    filteredOptions() {
      return this.options.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    noResult() {
      return this.filteredOptions.length === 0;
    },
  },
  methods: {
    focusInput() {
      this.$nextTick(() => {
        if (!this.$refs.searchbar) return;
        this.$refs.searchbar.focus();
      });
    },
    onClickSelectItem(value) {
      this.$emit('add', value);
    },
  },
};
</script>

<template>
  <div>
    <div class="pt-2 px-2">
      <div class="relative">
        <span class="absolute i-lucide-search top-2.5 size-3.5 left-3" />
        <input
          ref="searchbar"
          v-model="search"
          type="search"
          :placeholder="inputPlaceholder"
          class="reset-base outline-none w-full py-2 pl-10 pr-2 text-sm border-none rounded-lg bg-n-solid-1 text-slate-900 dark:text-slate-50"
        />
      </div>
    </div>

    <div class="px-2 overflow-auto max-h-[10rem]">
      <div class="flex flex-col gap-2">
        <ul class="py-2 mb-0" role="listbox">
          <li
            v-for="option of filteredOptions"
            :key="option.value"
            class="rounded-lg flex items-center justify-between w-full gap-2 px-3 py-2 text-sm transition-colors duration-150 cursor-pointer hover:bg-n-alpha-2"
            role="option"
            @click="onClickSelectItem(option)"
          >
            <span class="text-n-slate-12">
              {{ option.name }}
            </span>
          </li>
        </ul>
      </div>
      <ul
        v-if="noResult"
        class="py-1 mb-0 overflow-auto max-h-60"
        role="listbox"
      >
        <li class="px-3 py-2 text-sm text-slate-600 dark:text-slate-300">
          {{ noSearchResult }}
        </li>
      </ul>
    </div>
  </div>
</template>
